import { render, staticRenderFns } from "./StartTermicCourseConfirmationDialog.vue?vue&type=template&id=8ae6c558"
import script from "./StartTermicCourseConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./StartTermicCourseConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports